module.exports = __webpack_public_path__ + "static/media/download.dae4393a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/download.png
// module id = 357
// module chunks = 0